import { Principal } from '../application/authentication'
import { Proposer } from './types'

export const isAuthenticated = (
  policyholder: Proposer | undefined,
  principal: Principal,
): boolean =>
  principal.isAdmin ? !!policyholder?.accountRegistered : principal.isAuthenticated
